import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    /* @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');

    @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100&display=swap');

    @import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@100;200;600&display=swap'); */
    /* @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@200&display=swap'); */
    @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@200;400&display=swap');

    html{
        box-sizing: border-box;
        font-family:'Oswald', 'Roboto', 'Montserrat', sans-serif;


  /* max-width: 120ch; */
  /* padding: 3em 1em; */
  margin: auto;
  line-height: 1.75;
  /* font-size: 1.25em; */

    }
    
    *,*::before, *::after {
        box-sizing: inherit  ;
    }
    body{
        font-family:'Oswald', 'Roboto', 'Montserrat', sans-serif;
        padding:1px ;
        margin: 0;
        background-color: black ;
        background-color: #F5F4EF ;

  
    }   

    a, button{
        font-family:'Oswald', 'Roboto',  'Montserrat', sans-serif;
    }
/* 
h1,h2,h3,h4,h5,h6 {
    margin: 3em 0 1em;
} */
  
/* p,ul,ol { */
    /* margin-bottom: 2em; */
    /* color: #1d1d1d; */
    /* font-family: sans-serif; */
/* } */
`;



